export const getNewInputValue = (currentValue: string, newValue: string) => {
  const difference = newValue.replace(currentValue, '');
  if (difference.length > 4) {
    // Lets set a minimum of 4 characters to change the input value
    return difference;
  }
  // The customer is just typing
  return newValue;
};
